import type { IconSvgObject } from './types';

const Building01Icon: IconSvgObject = [
  ["path", { d: "M4 22H20", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M17.5 9H14M18 13H14M18 17H14", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M6 22V2H9C13.9706 2 18 6.02944 18 11V22", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default Building01Icon;
